export function readFlowMeetLink(flowState) {
  const link = flowState?.meet_link;
  return typeof link === 'string' && link.trim() ? link.trim() : '';
}

export function withMeetLink(text, meetLink) {
  const base = typeof text === 'string' ? text : '';
  if (!meetLink) return base;
  if (base.includes(meetLink)) return base;
  return base ? `${base}\n${meetLink}` : meetLink;
}
